import * as navigation from 'Navigation';
import {TabStateDefaults} from 'Navigation';

export default class BenchlingAppTabState extends navigation.TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'App',
      closeable: false,
      preferenceKey: 'benchling-app',
    };
  }
}
